module.exports = __webpack_public_path__ + "img/green-tick.e33f57b8.png";